var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-container"},[(_vm.$route.params.type === 'companyProfile')?_c('CompanyProfile'):_vm._e(),(_vm.$route.params.type === 'honor')?_c('CompanyHonors'):_vm._e(),(_vm.$route.params.type === 'news')?_c('News'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }